// General styling
export const BORDER_RADIUS = 16
export const LEFT_SAFE_ZONE_MARGIN = 176

export const LOGIN_ICON_WIDTH = 32
export const LOGIN_ICON_HEIGHT = 32

export const PAGINATION_BLOCK_HEIGHT = 52

// One day in milliseconds
export const INACTIVITY_THRESHOLD = 86400000

export const carouselsPrefix = {
  LIVE_AND_UPCOMING: 'live-and-upcoming',
  FAVORITES: 'favorites',
  CONTINUE_WATCHING: 'continue-watching',
}

export const WIDGETS_Z_INDEX = 99
